import React from 'react';
import './style.scss';

export default function InputContainer(props) {
  const inputProps = {
    className: `prevent input-field ${props.inputClass || ''}`,
    type: props.type || 'text',
    value: props.value,
    onChange: props.handleChange,
    disabled: props.disabled,
    name: props.name,
  };

  if (props.validate) {
    inputProps.onBlur = (event) => {
      props.validate(event.target.value);
    };
  }

  return (
    <div
      className={`${
        props.validationError ? 'input-container invalid' : 'input-container'
      } ${props.className || ''} box-input-container ${
        props.custom && 'custom-input-container'
      }`}
    >
      <div className="d-flex align-items-center box">
        <div className="h-100 d-flex justify-content-center align-items-center">
          <div className={`title ${props.placeholder ? '' : 'd-none'}`}>
            {props.placeholder}
          </div>
        </div>
        <div className="input-container flex-grow-1">
          <input {...inputProps} />
        </div>
      </div>

      {props.validationError && (
        <p className="input-validation-error mt-1 text-left">
          {props.validationError}
        </p>
      )}
    </div>
  );
}
